import { render, staticRenderFns } from "./hsnp_wizard_step_02_margin.vue?vue&type=template&id=21e4b230&scoped=true"
import script from "./hsnp_wizard_step_02_margin.vue?vue&type=script&lang=js"
export * from "./hsnp_wizard_step_02_margin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e4b230",
  null
  
)

export default component.exports